// Fichier de données clients pour le système de parrainage
// Ce fichier sera rempli avec les vrais clients depuis l'API

export const clients = [];

export const getClientDisplayName = (client) => {
  if (!client) return '';
  return `${client.prenom || ''} ${client.nom || ''}`.trim();
};

export const getClientById = (id) => {
  return clients.find(c => c.id === id) || null;
};
